import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

export const ADMIN_TOKEN_KEY = "zebaa_admin_token";
export const CUSTOMER_TOKEN_KEY = "zebaa_customer_token";

export const adminApi = () =>
  axios.create({
    baseURL: API,
    headers: { Authorization: `Bearer ${localStorage.getItem(ADMIN_TOKEN_KEY) || ""}` },
  });

export const customerApi = () =>
  axios.create({
    baseURL: API,
    headers: { Authorization: `Bearer ${localStorage.getItem(CUSTOMER_TOKEN_KEY) || ""}` },
  });

export const GOOGLE_CLIENT_ID = process.env.REACT_APP_GOOGLE_CLIENT_ID || "";

export function formatApiError(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).filter(Boolean).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export const formatGBP = (v) =>
  new Intl.NumberFormat("en-GB", { style: "currency", currency: "GBP" }).format(v);

export const getDeviceId = () => {
  let id = localStorage.getItem("zebaa_device_id");
  if (!id) {
    id = "dev_" + Math.random().toString(36).slice(2) + Date.now().toString(36);
    localStorage.setItem("zebaa_device_id", id);
  }
  return id;
};
